module.exports = require("vue2-leaflet");


//////////////////
// WEBPACK FOOTER
// external "vue2-leaflet"
// module id = 7
// module chunks = 0